// import type { AutoCompleteItem } from '/react4xp/components/react-hook-form/AutoCompleteItem.d';
import type { Phrases } from '../Phrases.d';
import type { IntoxicantOption } from '../../../../../site/parts/notificationFormAnonymous/IntoxicantOption.d';

import React from 'react';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import { useWatch } from 'react-hook-form';
import { Span } from '../../../../components/Element';
import { AutoComplete } from '../../../../components/react-hook-form/AutoComplete';
// import { Select } from '../../../../components/react-hook-form/Select';
import {
	// type Substance,
	COMMON_FIELD_NAME,
	COMMON_FREETEXT_FIELD_NAME,
	SUBSTANCE,
	SUBSTANCE_LEGEND_ID,
} from '../constants';


const MIXTURE_OR_OTHER: string[] = [
	SUBSTANCE.MIXTURE,
	SUBSTANCE.OTHER,
];


export const SubstanceAutoComplete = ({
	intoxicantOptions,
	phrases,
}: {
	intoxicantOptions: IntoxicantOption[];
	phrases: Phrases;
}): React.JSX.Element => {
	const { control, setValue } = useFormContext();
	const substance = useWatch({ control, name: COMMON_FIELD_NAME.SUBSTANCE }) as string;
	const label = phrases['notificationForm.common.substanceField.label'];

	React.useEffect(() => {
		if (!substance || !MIXTURE_OR_OTHER.includes(substance)) {
			// Yes, empty string can be set on optional text fields.
			setValue(COMMON_FREETEXT_FIELD_NAME.SUBSTANCE_OTHER, '', { shouldValidate: true });
		}
	}, [substance]);

	return (
		<AutoComplete
			aria-labelledby={SUBSTANCE_LEGEND_ID}
			errorSummaryLabel={label}
			fullWidth={false}
			hideLabel

			// ERROR: Causes aria-label="[object Object]" label="[object Object]"
			// label={<Span className='font-semibold text-xl'>{label}</Span>}
			// label={label} // Also sets aria-label
			label={undefined} // aria-labelledby should be enough, but Typings reqiure label to be set

			name={COMMON_FIELD_NAME.SUBSTANCE}
			items={intoxicantOptions}
		/>

	// There is something wrong with the width
	// <Select
	// 	aria-labelledby={SUBSTANCE_LEGEND_ID}
	// 	errorSummaryLabel={label}
	// 	fullWidth={false}
	// 	hideLabel
	// 	label={<Span className='font-semibold text-xl'>{label}</Span>}
	// 	name={COMMON_FIELD_NAME.SUBSTANCE}
	// 	options={intoxicantOptions.map(({id, label}) => ({key: id, label}))}
	// />
	);
};
